module.exports = __webpack_public_path__ + "img/gb-sct.1d630f66.svg";